import {store} from "../../redux/storeConfig/store";

const totalCalculationCart = (data) => {
    let count = 0;
    let _total_price = 0;
    let _total_offer = 0;
    let _total_final_price = 0;
    let _total_group_offer_price = 0;

    data.map(function (cartItem, index) {

        for (let i = 1; i <= parseInt(cartItem.item_qty); i++) {
            count++;
            _total_price += parseInt(cartItem.features[0].price)
            _total_offer += cartItem.features[0].offer ? parseInt(cartItem.features[0].offer) : 0
            if (cartItem.group_offer_price)
                _total_group_offer_price += parseInt(cartItem.group_offer_price);
            _total_final_price += parseInt(cartItem.features[0].final_price)
        }
    })
    store.dispatch({
        type: "CART",
        payload: {
            count: data.length,
            price: _total_final_price,
            group_offer_price: _total_group_offer_price,
        }
    });
    return {
        total_price: _total_price,
        total_offer: _total_offer,
        group_offer_price: _total_group_offer_price,
        total_final_price: _total_final_price
    }
}
export default totalCalculationCart;